export const config = {
	clientId: process.env.REACT_APP_AZURE_AD_SSO_CLIENT_ID,
    redirectUri: process.env.REACT_APP_AZURE_AD_SSO_RETURN_URL,
    scope: process.env.REACT_APP_AZURE_AD_SSO_SCOPE,
    authority: process.env.REACT_APP_AZURE_AD_SSO_AUTHORITY
};